import React, { useEffect, useRef, useState } from 'react'
import { Row, Col, Input, InputGroup, Tooltip, Whisper, Popover, Message } from 'rsuite'
import { numberThousandSeparator } from '../../../utils/formatterUtil'
import { requiredFiled, isValidators, getMaxLengthData } from '../../../utils/ValidatorUtils'
import CustomIconMessageInfo from '../../../widgets/CustomIconMessageInfo'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'
import ShowLimitLength from '../../utils/ShowLimitLength'
import classNames from 'classnames'
import InformationIncon from '../../help/InformationIncon'

export default function InputForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  index,
  onChange = () => {},
  isInputNumber = false,
  informational = null,
  showLimit,
  errorPopUp,
  ...props
}) {
  const colRef = useRef(null)

  const keyName = props?.name || schema?.name
  const labelMdLg = props.labelMdLg || 24
  const inputMdlg = props.inputMdlg || 24
  const preWidth = props.preWidth || ''
  const postWidth = props.postWidth || ''
  // const inputWidth = props.inputWidth ? props.inputWidth : ''
  const disabled = props.disabled || false
  // const value = props.value || schema.value
  const [inputValue, setInputValue] = useState(props.value || schema?.value || '')
  const maxLength = props.maxLength || getMaxLengthData(schema?.validators)?.value
  const showLimitLength = showLimit || !getMaxLengthData(schema?.validators)?.hide
  const placeholder = props.placeholder || schema?.hint || schema?.label
  const labelMsg = props.label || schema?.label

  useEffect(() => {
    var value = props.value || schema?.value || ''
    if (props.exValue) {
      value = props.value || ''
    }

    setInputValue(value)
    setValue(keyName, value)
  }, [props.value, schema])

  return (
    <>
      {/* <div ref={colRef}> */}
      {schema && (
        <Row style={{ ...props.style }}>
          {!errorPopUp && errors[keyName] && (
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
              <ErrorMessage error={errors[keyName]} />
            </Col>
          )}

          {!props.hideLabel && labelMsg && (
            <Col xs={24} sm={24} md={labelMdLg} lg={labelMdLg} style={{ marginTop: 10 }}>
              <p style={{ fontWeight: schema.isBolder ? 'bold' : undefined }}>
                {disabled
                  ? `${labelMsg} ${index || ''}`
                  : requiredFiled(schema.validators, `${labelMsg} ${index || ''}`)}
                {schema.note && <InformationIncon iconColor="#2da888" message={schema.note} />}
              </p>
            </Col>
          )}
          {schema.description && (
            <Col xs={24} sm={24} md={labelMdLg} lg={labelMdLg} style={{ marginTop: 10 }}>
              <CustomIconMessageInfo style={{ marginBottom: 10 }} contents={schema.description} />
            </Col>
          )}

          {informational && (
            <Col xs={24} sm={24} md={labelMdLg} lg={labelMdLg} style={{ marginTop: 10 }}>
              <Message
                showIcon
                type="info"
                description={
                  <div
                    dangerouslySetInnerHTML={{ __html: informational }}
                    style={{ marginTop: 15 }}
                  />
                }
              />
            </Col>
          )}

          <Col xs={24} sm={24} md={inputMdlg} lg={inputMdlg} style={{ marginTop: 5 }}>
            <Controller
              key={keyName}
              name={keyName}
              control={control}
              rules={disabled ? {} : isValidators(schema.validators)}
              defaultValue={inputValue}
              value={inputValue}
              render={(prop) => {
                return (
                  <InputGroup className={errors[keyName] ? 'is-error' : ''}>
                    {schema.preLabel && (
                      <InputGroup.Addon>
                        <p style={preWidth ? { width: preWidth } : {}}>{schema.preLabel}</p>
                      </InputGroup.Addon>
                    )}
                    <Whisper
                      key={keyName}
                      placement="top"
                      trigger=""
                      open={errorPopUp && errors[keyName]}
                      // container={() => colRef.current}
                      speaker={
                        <Popover style={{ backgroundColor: '#fcb1ab' }}>
                          {errors[keyName]?.message}
                        </Popover>
                      }
                    >
                      <Input
                        style={props.inputStyle}
                        className={classNames('rs-input', errors[keyName] && 'is-error')}
                        name={keyName}
                        disabled={disabled || schema.disabled}
                        //inputRef={disabled ? {} : register(isValidators(schema.validators))}
                        placeholder={
                          placeholder &&
                          placeholder +
                            (maxLength
                              ? ` จำนวนอักขระไม่เกิน ${numberThousandSeparator(maxLength)} อักขระ`
                              : '')
                        }
                        //defaultValue={props.value || schema?.value || ''}
                        value={inputValue}
                        rows={props.rows}
                        componentClass={props.componentClass}
                        maxLength={maxLength}
                        onChange={(value) => {
                          if (isInputNumber && isNaN(value)) {
                          } else {
                            prop.onChange(value)
                            setInputValue(value)
                            onChange(value)
                          }
                        }}
                      />
                    </Whisper>
                    {schema.postLabel && (
                      <InputGroup.Addon>
                        <p style={postWidth ? { width: postWidth } : {}}>{schema.postLabel}</p>
                      </InputGroup.Addon>
                    )}
                  </InputGroup>
                )
              }}
            />
            {showLimitLength && (
              <ShowLimitLength textLength={inputValue?.length || 0} maxLength={maxLength} />
            )}
          </Col>
        </Row>
      )}
      {/* </div> */}
    </>
  )
}
